import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Dropdown from 'react-bootstrap/Dropdown';

const MultiLangButtonGroup = ({ children, languages, selectedLanguage, onSelectLanguage, variant, disabled}) =>
  <Dropdown as={ButtonGroup}>
    {children}
    <Dropdown.Toggle split variant={variant} disabled={disabled}>
      {languages[selectedLanguage]}&nbsp;&nbsp;
    </Dropdown.Toggle>
    <Dropdown.Menu>
      {
        Object.entries(languages).map(([lang, name]) =>
          <Dropdown.Item key={lang}
            active={lang === selectedLanguage}
            eventKey={lang}
            onSelect={onSelectLanguage}>
            {name}
          </Dropdown.Item>)
      }
    </Dropdown.Menu>
  </Dropdown>;

export default MultiLangButtonGroup;
